import { createFileRoute, redirect } from "@tanstack/react-router";

// Consolidated into the unified Settings area (Fase 5).
export const Route = createFileRoute("/_authenticated/organization/settings")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/organization" });
  },
});
